import { lazy } from "react";
import { Navigate } from "react-router-dom";
const NotFound = lazy(() => import("./NotFound"));

const IndexOfSignin = lazy(() => import("../components/login/IndexOfSignin"));

const IndexOfWorkWise = lazy(
  () => import("../super-admin/WorkWise/IndexOfWorkWise")
);
const IndexOfDashboard = lazy(
  () => import("../super-admin/Dashboard/Dashboard")
);
const LAYOUT_TYPE = {
  TWO_COLUMN: "TWO_COLUMN",
};
const roles = { USER: "User", ADMIN: "Admin" };
const { USER, ADMIN } = roles;
const PRIVATE_ROUTES = [
  {
    path: "*",
    layoutType: null,
    component: <Navigate replace to={"/dashboard"} />,
    loadingFallback: null,
    accessTo: [ADMIN],
  },
  {
    path: "/dashboard",
    layoutType: null,
    component: <IndexOfDashboard />,
    loadingFallback: null,
    accessTo: [ADMIN],
  },
];
const PUBLIC_ROUTES = [
  {
    path: "/chat",
    layoutType: null,
    component: <IndexOfWorkWise />,
    loadingFallback: null,
  },
  {
    path: "/login",
    layoutType: null,
    component: <IndexOfSignin />,
    loadingFallback: null,
  },
  {
    path: "*",
    layoutType: null,
    component: <Navigate replace to={"/chat"} />,
    loadingFallback: null,
  },
];

export { LAYOUT_TYPE, PRIVATE_ROUTES, PUBLIC_ROUTES };
